// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert-warning {\n  text-align: center;\n  margin-bottom: 32px;\n}\n.alert-warning a {\n  text-decoration: none;\n}", "",{"version":3,"sources":["webpack://./src/pages/Favorites/Favorites.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;AACF;AAAE;EACE,qBAAA;AAEJ","sourcesContent":[".alert-warning {\n  text-align: center;\n  margin-bottom: 32px;\n  a {\n    text-decoration: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
